import { render, staticRenderFns } from "./checkEmailVerification.vue?vue&type=template&id=56e1fb88&scoped=true&"
import script from "./checkEmailVerification.vue?vue&type=script&lang=js&"
export * from "./checkEmailVerification.vue?vue&type=script&lang=js&"
import style0 from "./checkEmailVerification.vue?vue&type=style&index=0&id=56e1fb88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e1fb88",
  null
  
)

export default component.exports